import api from './api';

export function getTasas() {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/consult-rates`);
}

export function getTasasFilter(pagaduria, departamentoResidencia) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/consult-rates/${pagaduria}/${departamentoResidencia}`);
}

export function isPricing(idOficina) {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/is-office-model-pricing/${idOficina}`);
}

export function getTasasPricing(data,simulator) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/get-product-model-pricing/${simulator}`, data);
}

export function getTasasPricingAndCifin(data) {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/get-product-model-pricing`, data);
}
